/* Alba Stella — Curvd-style claim elements on the long-form product pages (owner P).
   Countdown to a real end date, ship-by date from the real processing time, reel arrows, extra video buttons.
   Placeholders and switches live in Liquid ('alba-g-proof'); nothing here invents numbers or dates. */
(function () {
  if (window.AlbaPdpProof) return;
  window.AlbaPdpProof = true;
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var TZ = 'Europe/Amsterdam';

  // Minutes Amsterdam is ahead of UTC at timestamp ts.
  function tzOffset(ts) {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date(ts)).forEach(function (p) { parts[p.type] = p.value; });
      var asUTC = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
      return Math.round((asUTC - ts) / 60000);
    } catch (e) { return 60; }
  }
  // "2026-10-31 23:59" (Amsterdam time) -> epoch ms, or NaN.
  function parseEnd(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59);
    var t = guess - tzOffset(guess) * 60000;
    var off2 = tzOffset(t);
    return guess - off2 * 60000;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  // Today 23:59:59 in Dutch time (Europe/Amsterdam) -> epoch ms (demo view only, see below).
  function endOfToday() {
    var now = Date.now();
    var local = new Date(now + tzOffset(now) * 60000);
    var guess = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), 23, 59, 59);
    var t = guess - tzOffset(guess) * 60000;
    return guess - tzOffset(t) * 60000;
  }

  /* ---------- Offer band countdown (never restarts; disappears at the end date) ----------
     Exception: data-countdown-state="demo" is only rendered in the demo view of the unpublished theme ('alba-g-demo-on',
     never for customers): Curvd's "ends today" timer to 23:59 today, which starts again the next day. */
  qsa('[data-pdp-countdown]').forEach(function (band) {
    var demo = band.getAttribute('data-countdown-state') === 'demo';
    var end = demo ? endOfToday() : parseEnd(band.getAttribute('data-pdp-countdown'));
    var live = band.getAttribute('data-countdown-state') === 'live';
    var timers = qsa('[data-countdown-text]', band);
    function expire() {
      var tpl = band.nextElementSibling;
      if (live && tpl && tpl.hasAttribute('data-countdown-fallback')) {
        tpl.parentNode.replaceChild(document.importNode(tpl.content, true), tpl);
        band.parentNode.removeChild(band);
      } else if (live) {
        band.parentNode.removeChild(band);
      } else {
        timers.forEach(function (t) { t.textContent = '00:00:00'; });
      }
    }
    if (!timers.length) return;
    if (isNaN(end)) { expire(); return; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0 && demo) { end = endOfToday(); if (end <= Date.now()) end += 86400000; left = Math.floor((end - Date.now()) / 1000); }
      if (left <= 0) { clearInterval(iv); expire(); return; }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), mi = Math.floor(left % 3600 / 60), s = left % 60;
      var txt = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(mi) + ':' + pad(s);
      timers.forEach(function (t) { t.textContent = txt; });
    }
    var iv = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Ship-by date: today + N working days (Sat/Sun skipped), Amsterdam time ---------- */
  var DAYS = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var MONTHS = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  qsa('[data-pdp-shipby]').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-days'), 10) || 2;
    var now = Date.now();
    var local = new Date(now + tzOffset(now) * 60000); // Amsterdam wall clock in UTC fields
    var d = new Date(Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate()));
    while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); var wd = d.getUTCDay(); if (wd !== 0 && wd !== 6) n--; }
    var out = qsa('[data-shipby-date]', el);
    out.forEach(function (o) { o.textContent = DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; });
  });

  /* ---------- Reel rows: arrow tabs on phones ---------- */
  qsa('[data-pdp-reels]').forEach(function (box) {
    var track = box.querySelector('[data-reels-track]');
    var prev = box.querySelector('[data-reels-prev]'), next = box.querySelector('[data-reels-next]');
    if (!track) return;
    function step() { var it = track.firstElementChild; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; return it ? it.getBoundingClientRect().width + gap : 180; }
    function upd() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.classList.toggle('is-off', track.scrollLeft <= 1);
      if (next) next.classList.toggle('is-off', track.scrollLeft >= max);
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* ---------- Video buttons outside the product hero (Instagram section) ---------- */
  qsa('[data-pdp-video]').forEach(function (b) {
    if (b.closest('[data-pdp]')) return; // handled by alba-pdp.js
    b.addEventListener('click', function () {
      var v = b.parentNode.querySelector('video'); if (!v) return;
      if (v.paused) { v.muted = false; v.play(); b.classList.add('is-playing'); } else { v.pause(); b.classList.remove('is-playing'); }
    });
  });
})();
